import { Link } from "react-router-dom";
import { MessageCircle, Phone, Calendar } from "lucide-react";
import { Button } from "@/components/ui/button";
import { PHONE_PRIMARY, PHONE_PRIMARY_TEL, getWhatsAppUrl } from "@/lib/constants";
import { track, trackCall, trackWhatsApp } from "@/lib/analytics";

interface Props {
  title?: string;
  subtitle?: string;
  whatsappMessage?: string;
  ctaLabel?: string;
  ctaHref?: string;
}

const CTASection = ({
  title = "Ready to Smile with Confidence?",
  subtitle = "Book a consultation with Dr. Khushboo Mutha and the Mutha's Advanced Dental Care team in Kalyan. We'll listen, examine and give you a clear written treatment plan — no pressure, no surprises.",
  whatsappMessage,
  ctaLabel = "Book My Consultation",
  ctaHref = "/book-appointment",
}: Props) => (
  <section className="py-16 md:py-20 bg-primary text-primary-foreground">
    <div className="container max-w-3xl text-center">
      <h2 className="font-heading text-2xl md:text-4xl font-light mb-4 text-primary-foreground">{title}</h2>
      <p className="text-primary-foreground/85 mb-8 leading-relaxed">{subtitle}</p>
      <div className="flex flex-col sm:flex-row sm:flex-wrap gap-3 justify-center">
        <Button asChild variant="gold" size="lg" className="max-w-full h-auto min-h-12 py-3 px-4 whitespace-normal tracking-normal">
          {ctaHref.startsWith("#") ? (
            <a href={ctaHref} onClick={() => track("book_appointment_click", { source: "cta_section" })}>
              <Calendar className="h-4 w-4 mr-2" />{ctaLabel}
            </a>
          ) : (
            <Link to={ctaHref} onClick={() => track("book_appointment_click", { source: "cta_section" })}>
              <Calendar className="h-4 w-4 mr-2" />{ctaLabel}
            </Link>
          )}
        </Button>
        <Button asChild size="lg" className="bg-whatsapp text-whatsapp-foreground hover:bg-whatsapp/90 tracking-normal">
          <a href={getWhatsAppUrl(whatsappMessage)} target="_blank" rel="noopener noreferrer" onClick={() => trackWhatsApp("cta_section")}>
            <MessageCircle className="h-4 w-4 mr-2" />WhatsApp Now
          </a>
        </Button>
        <Button asChild size="lg" variant="outline" className="bg-transparent border-primary-foreground/40 text-primary-foreground hover:bg-primary-foreground/10 tracking-normal">
          <a href={PHONE_PRIMARY_TEL} onClick={() => trackCall("cta_section")}><Phone className="h-4 w-4 mr-2" />{PHONE_PRIMARY}</a>
        </Button>
      </div>
    </div>
  </section>
);

export default CTASection;